import React from "react";
import {Row, Button} from "react-bootstrap";
import {connect} from "react-redux";
import {JoinCreateAccountConstants, URLs} from "../../common/constants";
import {showFBErrorMessage, setEnableFbButton} from "../../actions/login/logInActions";
import {initFacebook} from "../../common/utils";
import {translate} from "../../i18n/translate.js";
import style from "../../css/join/joinCreateAccount.less";

class JoinCreateAccount extends React.Component {
    componentWillMount() {
        initFacebook(this.props.facebookAppId, false, this.enableFBButton);
    }

    goToContactDetails = () => {
        this.props.setMemberData({isFBLogin: false});
        this.props.setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS);
    };

    goToLogin = () => {
        this.props.setCreateAccountPage(JoinCreateAccountConstants.LOGIN);
    };

    statusChangeCallback = (response, logOut, shouldNotLogin) => {
        if (response.status === 'connected') {
            if (response.authResponse) {
                FB.api('/me',{fields:'id,first_name,last_name,email'}, function(response) {
                    this.handleFBConnect(response);
                }.bind(this));
            } else {
                console.log('User cancelled login or did not fully authorize.');
            }
        } else if (!shouldNotLogin) {
            FB.login(function(response) {
                this.statusChangeCallback(response, false, true) ;
            }.bind(this));
        }
    };

    handleFBConnect = (response) => {
        const member = {email: response.email, firstName: response.first_name,
            lastName: response.last_name, facebookId:response.id, isFBLogin: true};
        this.props.setMemberData(member);
        this.props.createFacebookMember(member, this.props.isGuestUser);
    };

    checkLoginState = () => {
        if (!this.isFBLoaded())
            return;
        const that = this;
        FB.getLoginStatus(function(response) {
            that.statusChangeCallback(response);
        });
    };

    enableFBButton = () => {
        this.props.setEnableFbButton(true);
    };

    isFBLoaded = () => {
        if (typeof(FB) === 'undefined'){
            initFacebook(this.props.facebookAppId, true, this.enableFBButton);
            this.props.showFBErrorMessage();
            return false;
        }
        return true;
    };

    render() {
        const styleClass = "login-button" + (this.props.showLoading?" loading":"");
        return (<div className="border-container border-container-join">
            <div className="inner-container">
                <div className="form-container container-fluid">
                    <Row className="sign-in-fb btn-fb-join">
                        <Button className={"button fb-" + styleClass} onClick={this.checkLoginState} disabled={!this.props.fbButtonEnabled}>
                            <div className="btn-fb-text">
                                <div className="fb-img"/>
                                {translate("Create account with Facebook")}
                            </div>
                        </Button>
                    </Row>
                    <Row className="email-log-in btn-email-join">
                        <Button bsStyle="primary" className={"button email-" + styleClass} id="btnlogin"
                                onClick={this.goToContactDetails}>
                            <div className="btn-email-text">{translate("Create account with Email")}</div>
                        </Button>
                    </Row>
                </div>
                <div className="create-account-text">{translate("_createAccountBottomNote")}</div>
                {
                    this.props.clientViewPort.isXs && this.props.flowType === URLs.JOIN ? undefined :
                        <div className="bottom-container"/>
                }
            </div>
        </div>);
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showFBErrorMessage: () => {
            dispatch(showFBErrorMessage());
        },
        setEnableFbButton: (enableFBButton) => {
            dispatch(setEnableFbButton(enableFBButton));
        }
    }
};

export default connect(null, mapDispatchToProps)(JoinCreateAccount);


// WEBPACK FOOTER //
// ./src/containers/join/JoinCreateAccount.js